// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"6e108dfe","239":"1fc04112","455":"858ee705","977":"4d3abeee"}[chunkId] + ".chunk.js";
};